// custom sort function - datetime
export const sortByDateTimeFunc = ((rowA, rowB, id, desc) => {
  if (rowA.values[id] > rowB.values[id]) return 1;
  if (rowB.values[id] > rowA.values[id]) return -1;
  return 0;
});

export const sortAlphanumericFunc = ((rowA, rowB, id, desc) => {
  return (rowA.values[id]).localeCompare(rowB.values[id]);
});